module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_cat_EN.294ffd60.png";